<ion-app>
  <ion-router-outlet id="content1"></ion-router-outlet>
  <app-menu></app-menu>
  <app-build-optimizer-bugfix></app-build-optimizer-bugfix>
</ion-app>
